import gql from "graphql-tag";

export const DELETE_ONE_TELEGRAM_MENU = gql`
  mutation ($id: ID!) {
    deleteOneTelegramMenu(input: { id: $id }) {
      id
    }
  }
`;
